import { Box, BoxProps } from "@biblioteksentralen/react";
import { digitalLibraryServiceCategoryIcons } from "@libry-content/common";
import { DigitalLibraryServiceCategory } from "@libry-content/types";

type ServiceCategoryIconProps = BoxProps & { category: DigitalLibraryServiceCategory };

export const ServiceCategoryIcon = ({ category, ...boxProps }: ServiceCategoryIconProps) => {
  const Icon = digitalLibraryServiceCategoryIcons[category];

  if (!Icon) return null;

  return (
    <Box
      padding={{ base: "0.5rem", lg: "0.625rem" }}
      borderRadius="50%"
      width="2.5rem"
      height="2.5rem"
      position="relative"
      aria-hidden
      {...boxProps}
    >
      <Icon width="100%" height="100%" />
    </Box>
  );
};
